
import { Component, Vue } from "vue-property-decorator";
import { AuthModule } from "@/store/auth";

@Component({})
export default class ExpiredLink extends Vue {
  public get eventInfo() {
    let evt = AuthModule.currentEventInfo;
    if (!evt || !evt.name) {
      try {
        const stored = sessionStorage.getItem("expiredEvent");
        if (stored) {
          evt = JSON.parse(stored);
        }
      } catch (e) {
        // ignore parsing error
      }
    }
    return evt;
  }

  public closeWindow(): void {
    window.close();
  }
}
